<template>
  <div v-if="order.shipping.pickup.isPickupAvailable" class="body-2">
    <template v-if="!order.shipping.pickup.isPickupCancelled">
      <div
        v-if="
          order.shipping.pickup.pickupStartDate &&
          order.shipping.pickup.pickupEndDate
        "
        class="mb-8"
        data-allow-mismatch
      >
        {{
          i18n.date(
            new Date(order.shipping.pickup.pickupStartDate),
            SHORT_DATE_FORMAT,
          )
        }}
        <br />
        {{
          i18n(translations.pickupBetween, {
            startHour: i18n.date(
              new Date(order.shipping.pickup.pickupStartDate),
              {
                hour: 'numeric',
                minute: 'numeric',
              },
            ),
            endHour: i18n.date(new Date(order.shipping.pickup.pickupEndDate), {
              hour: 'numeric',
              minute: 'numeric',
            }),
          })
        }}
      </div>

      <RevLink @click="handleCancelPickup">
        {{ i18n(translations.cancelPickup) }}
      </RevLink>

      <CancelPickupModal :orderId="order.id" :refreshOrders />
    </template>

    <template v-if="order.shipping.pickup.isPickupCancelled">
      <div class="text-static-warning-hi body-2">
        {{ i18n(translations.pickupCancelled) }}
      </div>

      <RevLink @click="handleRequestPickup">
        {{ i18n(translations.requestPickup) }}
      </RevLink>

      <RequestPickupDrawer :orderId="order.id" :refreshOrders />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import { SHORT_DATE_FORMAT } from '~/constants/dateTimeFormats'

import type { Order } from '../../../../../../Tab.types'

import translations from './Pickup.translations'
import { MODAL_NAME as CANCEL_PICKUP_MODAL } from './components/CancelPickupModal/CancelPickupModal.constants'
import CancelPickupModal from './components/CancelPickupModal/CancelPickupModal.vue'
import { MODAL_NAME as REQUEST_PICKUP_DRAWER } from './components/RequestPickupDrawer/RequestPickupDrawer.constants'
import RequestPickupDrawer from './components/RequestPickupDrawer/RequestPickupDrawer.vue'

const i18n = useI18n()

const props = defineProps<{ order: Order; refreshOrders: () => void }>()

function handleCancelPickup() {
  openModal(CANCEL_PICKUP_MODAL + props.order.id)
}

function handleRequestPickup() {
  openModal(REQUEST_PICKUP_DRAWER + props.order.id)
}
</script>
